import * as React from "react";
const SvgIcChevronUp = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13 10L8 5L3 10", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
export default SvgIcChevronUp;
